import React from 'react';
import { RouteButton } from '../../form';
import styles from './UnderConstructionPage.module.css';

const UnderConstructionPage: React.FC = () => (
  <div className={styles.container}>
    <div className={styles.status}>This page is currently</div>
    <p className={styles.heading}>UNDER CONSTRUCTION</p>
    <p>
      Please check back soon
    </p>
    <RouteButton to="/" variant="primary" replace>
      Back to Home Page
    </RouteButton>
  </div>
)

export default UnderConstructionPage;
